/**
 * Model reprezentujący zaplanowane przypomnienie / zaproszenie na kolejną wizytę.
 */
export class NextVisitReminder {


  /** Wewnętrzny identyfikator numeryczny. */
  public idx: number;
  /** Globalnie unikalny identyfikator przypomnienia (UUID). */
  public uuid: string;
  public created: Date;
  public modified: Date;
  public deleted: Date;


  /** Identyfikator właściciela zwierzęcia (adresata przypomnienia). */
  public userUUID: string;
  public aniId: string;
  /** Identyfikator zwierzęcia (pacjenta). */
  public petUUID: string;
  /** Nazwa pacjenta (do szybkiego wyświetlania w powiadomieniach). */
  public aniName: string;

  /** Zewnętrzny identyfikator wizyty z systemu KlinikiXP. */
  public visitXpId: number;
  /** Identyfikator wizyty z Vetineo. */
  public vetineoVisitUUID: string;

  /** Identyfikator konkretnego typu wizyty u konkretnego lekarza (usługa docelowa). */
  public vetDoctorVetVisitTypeUUID: string;
  /** Identyfikator pakietu/grupy usług. */
  public vetineoVisitTypeBundleUUID: string;
  /** Tekstowa nazwa typu wizyty. */
  public visitType: string;

  /** Nazwa szczepionki. */
  public vaccName: string;
  /** Flaga oznaczająca szczepienie przeciwko wściekliźnie.
   */
  public vaccIsRabies: boolean;
  /** Flaga oznaczająca, czy szczepienie wymaga powtórzenia (tzw. dawka przypominająca/booster). */
  public vaccRepeat: boolean;
  /** Docelowa data kolejnego szczepienia. */
  public vaccNextDate: Date;

  /** Planowana data i czas wysłania pierwszej wiadomości do właściciela. */
  public scheduledFirstMessage: string;
  /** Rzeczywista data i czas fizycznego wysłania powiadomienia. */
  public sendFirstMessage: Date;
  /** Identyfikator zadania/logu dla wiadomości e-mail. */
  public firstMailId: string;
  /** Identyfikator zadania/logu dla powiadomienia Push do aplikacji mobilnej. */
  public firstPushId: string;

  /** Vetcode placówki weterynaryjnej. */
  public vetcodeId: number;
  /** Identyfikator lekarza prowadzącego/zlecającego. */
  public doctorId: number;
  /** Imię i nazwisko lekarza. */
  public doctorName: string;


  /** Czy przypomnienie jest cykliczne. */
  public repeat: boolean;
  /** Flaga usunięcia z poziomu interfejsu (soft-delete UI). */
  public setToDelete: boolean;
  /** Oznaczenie przypomnienia o wysokim priorytecie. */
  public isImportant: boolean;
  /** Oznaczenie tzw. przypomnienia "Flash" (szybkie, natychmiastowe powiadomienie). */
  public isFlash: boolean;
  /** Flaga informująca, że w tym konkretnym przypadku wymagany jest kontakt telefoniczny z klientem. */
  public isPhoneNeeded: boolean;
  /** Dodatkowa notatka wewnętrzna dla personelu kliniki. */
  public description: string;

}
